import api from '../api/client';

const getAll = async (appId) => {
    if (!appId) throw new Error('App ID is required');
    const res = await api.get(`/api/roles/get-all-roles`, { params: { app_id: appId } });
    return res?.data?.data;
};

const addRole = async (appId, payload) => {
    const res = await api.post('/api/roles/add-new-role', payload, { params: { app_id: appId } });
    return res?.data;
};

const updateStatus = async (appId, payload) => {
    const res = await api.post('/api/roles/update-role-status', payload, { params: { app_id: appId } });
    return res?.data;
};

const deleteRole = async (appId, payload) => {
    const res = await api.delete('/api/roles/delete-role-from-app', {
        params: { app_id: appId },
        data: payload,
    });
    return res?.data;
};

const getRoleDetail = async (appId, rolename) => {
    if (!appId || !rolename) throw new Error('App ID and role name are required');
    const res = await api.get(`/api/roles/get-role-detail/${encodeURIComponent(rolename)}`, {
        params: { app_id: appId },
    });
    return res?.data?.data;
};

const rolesService = { getAll, addRole, updateStatus, deleteRole, getRoleDetail };

export default rolesService;
